export default __webpack_public_path__ + "static/media/fileExcelLight.cd16faea.svg";